import { action, makeAutoObservable, observable } from 'mobx';

export default class TextFilter {

    @observable
    text: string = '';

    constructor() {
        this.text = '';
        makeAutoObservable(this);
    }

    @action
    changeSearchText(value: string): void {
        this.text = value;
    }
}